var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgActivity = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Activity")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/illustration/activity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)",
    fill: "#FFEEF2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.1085515 C0,31.2135651 9.00284965,40.2162162 20.1081081,40.2162162 C31.2133666,40.2162162 40.2162162,31.2135651 40.2162162,20.1085515 C40.2162162,9.00353786 31.2142533,0.00177339725 20.1089948,0.000886698627 L20.1089948,0 L0.000886718177,0 C0.000886718177,0 0,20.095251 0,20.1085515",
    id: "Fill-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.750000, 8.666667)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entrance"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,26.902439 L32.3696731,26.902439 L28.1940109,22.7395074 C27.7640759,22.3108832 27.7640759,21.6159461 28.1940109,21.1873218 C28.6239459,20.7586976 29.3210082,20.7586976 29.7509432,21.1873218 L35.8059891,27.2239072 C36.2359241,27.6525314 36.2359241,28.3474686 35.8059891,28.7760928 L29.7509432,34.8126781 C29.3210082,35.2413024 28.6239459,35.2413024 28.1940109,34.8126781 C27.7640759,34.3840539 27.7640759,33.6891168 28.1940109,33.2604925 L32.3696731,29.097561 L22,29.097561 L22,43 L42,43 L42,13 L22,13 L22,26.902439 Z M19.9688474,26.9148936 L19.9688474,12.0851064 C19.9688474,11.4858187 20.4542209,11 21.0529595,11 L42.9158879,11 C43.5146265,11 44,11.4858187 44,12.0851064 L44,43.9148936 C44,44.5141813 43.5146265,45 42.9158879,45 L21.0529595,45 C20.4542209,45 19.9688474,44.5141813 19.9688474,43.9148936 L19.9688474,29.0851064 L16.0841121,29.0851064 C15.4853735,29.0851064 15,28.5992877 15,28 C15,27.4007123 15.4853735,26.9148936 16.0841121,26.9148936 L19.9688474,26.9148936 Z",
    id: "Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,26.902439 L32.3696731,26.902439 L28.1940109,22.7395074 C27.7640759,22.3108832 27.7640759,21.6159461 28.1940109,21.1873218 C28.6239459,20.7586976 29.3210082,20.7586976 29.7509432,21.1873218 L35.8059891,27.2239072 C36.2359241,27.6525314 36.2359241,28.3474686 35.8059891,28.7760928 L29.7509432,34.8126781 C29.3210082,35.2413024 28.6239459,35.2413024 28.1940109,34.8126781 C27.7640759,34.3840539 27.7640759,33.6891168 28.1940109,33.2604925 L32.3696731,29.097561 L22,29.097561 L22,43 L42,43 L42,13 L22,13 L22,26.902439 Z",
    id: "Path",
    fill: "#D8F1EC",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActivity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/activity.578de7a7.svg";
export { ForwardRef as ReactComponent };